// Localized UI strings for the FAQ webview, ported from the Zendesk FAQ theme
// (language.js): the header title, the email-support message and the
// email-support button label.
//
// Keys follow language.js (en, ar, zhCn, zhTw, fr, de, hi, id, it, ja, ko, ms,
// pt, ru, es, th, tr, vi). `t(name, locale)` takes the resolved Zendesk locale
// (e.g. "ko", "en-us", "zh-cn") and falls back to English.

const STRINGS = {
  faqTitle: {
    en: "FAQ",
    ar: "الأسئلة الشائعة",
    zhCn: "常见问题",
    zhTw: "常見問題",
    fr: "FAQ",
    de: "FAQ",
    hi: "FAQ",
    id: "FAQ",
    it: "FAQ",
    ja: "FAQ",
    ko: "자주하는 질문",
    ms: "FAQ",
    pt: "FAQ",
    ru: "FAQ",
    es: "Ayuda",
    th: "คำถามที่พบบ่อย",
    tr: "SSS",
    vi: "FAQ",
  },
  emailSupportMsg: {
    ar: "اتصل بفريق الدعم التقني مباشرة!<br/>يمكنك الحصول على إجابات بشكل أسرع إذا قمت بإرفاق لقطة شاشة أو تسجيل شاشة لمشكلتك!",
    en: "Contact our Support Team directly!<br/>You can get a quicker response if you attach a screenshot or screen record of the issue!",
    fr: "Contactez directement notre équipe de support!<br/>Vous pouvez obtenir des réponses plus rapidement si vous joignez une capture d'écran ou un enregistrement d'écran de votre problème!",
    de: "Kontaktieren Sie direkt unser Support-Team!<br/>Sie erhalten schneller Antworten, wenn Sie einen Screenshot oder eine Bildschirmaufnahme Ihres Problems anhängen!",
    hi: "हमारी सहायता टीम से सीधे संपर्क करें!<br/>यदि आप अपनी समस्या का स्क्रीनशॉट या स्क्रीन रिकॉर्डिंग संलग्न करते हैं तो हम और तेजी से आपको उत्तर दे सकते हैं!",
    id: "Hubungi Tim Dukungan kami secara langsung!<br/>Anda bisa mendapatkan jawaban lebih cepat jika Anda melampirkan screenshot atau rekaman layar masalah Anda!",
    it: "Contatta direttamente il nostro Team di Supporto!<br/>Puoi ottenere risposte più velocemente se alleghi uno screenshot o una registrazione dello schermo con il problema!",
    ja: "弊社サポートチームまで直接ご連絡ください！<br/>ご指摘の問題のスクリーンショットや画面録画を添付いただけますと、より迅速かつ詳細な回答が可能となります。",
    ko: "아래 '이메일 문의'를 통해 관련 스크린샷이나 녹화 영상을 함께 보내주시면, 보다 원활한 문제 해결이 가능합니다.",
    ms: "Hubungi Pasukan Sokongan kami secara langsung!<br/>Anda boleh mendapatkan jawapan dengan lebih cepat jika anda melampirkan tangkapan skrin atau rakaman skrin masalah anda!",
    pt: "Contate o time de suporte diretamente!<br/>Você consegue respostas mais rápidas ao inserir uma captura de tela ou gravação de tela do seu problema!",
    ru: "Свяжитесь с нашей службой поддержки напрямую!<br/>Вы можете получить ответ на вашу проблему быстрее, если приложите скриншот или запись экрана!",
    zhCn: "联络我们的支持团队！<br/>请附上问题的相关截图， 以便能迅速解决您的问题！",
    zhTw: "聯絡我們的服務團隊！<br/>請附上問題的相關截圖， 以便能迅速解決您的問題！",
    es: "¡Comuníquese con nuestro equipo de soporte directamente!<br/>¡Puede obtener respuestas más rápido si incluye una captura de pantalla o una grabación de pantalla de su problema!",
    th: "ติดต่อทีมช่วยเหลือโดยตรงได้ทันที!<br/>คุณจะได้รับคำตอบเร็วขึ้นหากคุณแนบภาพหน้าจอหรือวิดีโออัดหน้าจอของปัญหามาให้เรา!",
    tr: "Doğrudan Destek Ekibimiz ile iletişime geçin!<br/>Sorununuzun ekran görüntüsünü veya ekran kaydını eklerseniz daha hızlı yanıt alabilirsiniz!",
    vi: "Liên hệ trực tiếp với Nhóm Hỗ Trợ của chúng tôi!<br/>Bạn có thể nhận được câu trả lời nhanh hơn nếu bạn đính kèm ảnh chụp màn hình hoặc bản ghi màn hình về vấn đề của mình!",
  },
  emailSupportBtn: {
    ar: "الدعم التقني",
    en: "Email Support",
    fr: "Assistance Email",
    de: "E-Mail-Support",
    hi: "ई - मेल सहाय",
    id: "Dukungan Email",
    it: "Supporto Email",
    ja: "Eメールサポート",
    ko: "이메일 문의",
    ms: "Sokongan E-mel",
    pt: "Mande email para o suporte",
    ru: "Связаться по Эл. почте",
    zhCn: "技术支持",
    zhTw: "技術支持",
    es: "Soporte por E-mail",
    th: "การช่วยเหลือทางอีเมล",
    tr: "Eposta Desteği",
    vi: "Email Hỗ Trợ",
  },
};

// Resolved Zendesk locale -> language.js key.
const LOCALE_TO_KEY = {
  ar: "ar",
  "en-us": "en",
  fr: "fr",
  de: "de",
  hi: "hi",
  id: "id",
  it: "it",
  ja: "ja",
  ko: "ko",
  ms: "ms",
  pt: "pt",
  ru: "ru",
  "zh-cn": "zhCn",
  es: "es",
  th: "th",
  tr: "tr",
  vi: "vi",
};

export function langKey(locale) {
  return LOCALE_TO_KEY[String(locale || "").toLowerCase()] || "en";
}

export function t(name, locale) {
  const group = STRINGS[name] || {};
  const key = langKey(locale);
  return group[key] != null ? group[key] : group.en;
}
